"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var AccountsListAdmin_module_css_1 = __importDefault(require("./AccountsListAdmin.module.css"));
var ra_data_simple_rest_1 = __importDefault(require("ra-data-simple-rest"));
var react_admin_1 = require("react-admin");
var RALayout_1 = __importDefault(require("@/Layouts/RALayout"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var react_i18next_1 = require("react-i18next");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var useTypedPage_1 = __importDefault(require("@/Hooks/useTypedPage"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Pagination_1 = __importDefault(require("../common/ReactAdmin/Pagination"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var material_1 = require("@mui/material");
var theme = __assign(__assign({}, RAStyles_1.RaDatagridTheme), { sidebar: {
        width: 0,
        closedWidth: 0, // The default value is 55
    } });
var RaDataGridSx = {
    "& .RaDatagrid-table": {
        marginTop: "0px"
    },
    "& .RaDatagrid-headerCell": {
        backgroundColor: "var(--secondary-color-tinted)",
        fontFamily: "Geomanist-Bold",
        fontSize: "13px",
        color: "var(--info-color)",
        borderBottom: "unset",
    },
    "& .RaDatagrid-headerRow": {
        height: "52px",
    },
    "& .RaDatagrid-headerCell:first-of-type": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopRightRadius: 0,
        width: "200px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(2)": {
        width: "100px",
    },
    "& .RaDatagrid-headerCell:nth-of-type(3)": {
        width: "150px",
    },
    "& .RaDatagrid-headerCell:last-child": {
        borderRadius: "14px",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
        borderTopLeftRadius: 0,
        width: "190px",
    },
    "& .RaDatagrid-row": {
        height: "52px",
        borderBottom: "1px #D2D2D2 solid",
    },
    "& .RaDatagrid-row:last-child": {
        borderBottom: "unset",
    }
};
var SwitchAccountField = function () {
    var page = (0, useTypedPage_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    var switchAccount = function () {
        ApiManager_1.default.switchCurrentAccount(page.props.user.id, record).then(function () {
            window.location.replace("/dashboard");
        });
    };
    if (!record)
        return;
    return (react_1.default.createElement(react_admin_1.WrapperField, { sortable: false },
        react_1.default.createElement("div", { onClick: switchAccount, className: "d-flex align-items-center" },
            react_1.default.createElement(q_play_components_1.Button, { text: t("Sign into account"), isBold: false }))));
};
var ElevateToPartnerField = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    var _a = (0, react_1.useState)(false), openDialog = _a[0], setOpenDialog = _a[1];
    var logger = q_play_core_1.logManager.getLogger();
    var refresh = (0, react_admin_1.useRefresh)();
    var elevateToPartner = function () {
        ApiManager_1.default.elevateToPartner(record)
            .then(function () {
            setOpenDialog(false);
            refresh();
        })
            .catch(function (e) {
            logger.error(t("Elevating account to partner failed"), e);
            setOpenDialog(false);
        });
    };
    var handleOpenDialog = function () {
        setOpenDialog(true);
    };
    var handleCloseDialog = function () {
        setOpenDialog(false);
    };
    if (!record)
        return;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_admin_1.WrapperField, { sortable: false },
            react_1.default.createElement("div", { className: "d-flex align-items-center" }, record.id !== 1 && (react_1.default.createElement(material_1.Tooltip, { title: record.is_reseller === 1 ? "This account is already a partner account" : "Elevate account to partner" },
                react_1.default.createElement("span", null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faElevator, onClick: record.is_reseller === 1 ? undefined : handleOpenDialog, className: "".concat(AccountsListAdmin_module_css_1.default["elevate-icon"], " ").concat(record.is_reseller === 1 ? AccountsListAdmin_module_css_1.default["disabled-button"] : ""), "data-cy": "elevateToPartnerIcon" })))))),
        react_1.default.createElement(material_1.Dialog, { open: openDialog, onClose: handleCloseDialog, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", fullWidth: true, "data-cy": "elevateToPartnerDialog" },
            react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title" }, t("Elevate to Partner")),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.DialogContentText, { id: "alert-dialog-description" }, t("Are you sure you want to elevate this account to partner?"))),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(q_play_components_1.Button, { onClick: handleCloseDialog, style: { marginRight: "15px" }, size: "normal", text: t("Cancel"), variant: "secondary" }),
                    react_1.default.createElement(q_play_components_1.Button, { onClick: elevateToPartner, style: { backgroundColor: "#A1C038", width: "136px", color: "var(--info-color)" }, size: "normal", text: t("Update"), dataCy: "elevateToPartnerButton" }))))));
};
var ChangePartnerField = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(false), openDialog = _a[0], setOpenDialog = _a[1];
    var _b = (0, react_1.useState)([]), accounts = _b[0], setAccounts = _b[1];
    var _c = (0, react_1.useState)(""), selectedAccount = _c[0], setSelectedAccount = _c[1];
    var record = (0, react_admin_1.useRecordContext)();
    var page = (0, useTypedPage_1.default)();
    var logger = q_play_core_1.logManager.getLogger();
    var _d = (0, react_1.useState)(""), updatedResellerId = _d[0], setUpdatedResellerId = _d[1];
    var currentResellerId = updatedResellerId !== "" ? updatedResellerId : record.reseller_id;
    var handleChange = function (event) {
        setSelectedAccount(event.target.value);
    };
    var handleOpenDialog = function () {
        setOpenDialog(true);
        setSelectedAccount("");
    };
    var handleCloseDialog = function () {
        setOpenDialog(false);
    };
    (0, react_1.useEffect)(function () {
        var fetchData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var accountsResponse, transformedResponse, partnerAccounts, currentResellerAccount;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.getAccountsForUserByUserId(page.props.user.id)];
                    case 1:
                        accountsResponse = _b.sent();
                        transformedResponse = accountsResponse.map(function (account) { return (__assign(__assign({}, account), { is_reseller: account.is_reseller === 1 })); });
                        partnerAccounts = transformedResponse.filter(function (account) { return account.is_reseller && account.id !== record.id; });
                        setAccounts(partnerAccounts.map(function (account) { return ({ label: account.name, value: account }); }));
                        currentResellerAccount = partnerAccounts.find(function (account) { return account.id === currentResellerId; });
                        setSelectedAccount(currentResellerAccount ? currentResellerAccount.id : ((_a = partnerAccounts[0]) === null || _a === void 0 ? void 0 : _a.id) || "");
                        return [2 /*return*/];
                }
            });
        }); };
        if (openDialog) {
            fetchData();
        }
    }, [openDialog]);
    (0, react_1.useEffect)(function () {
        var skipButton = document.querySelector(".skip-nav-button");
        var originalDisplay;
        if (skipButton instanceof HTMLElement) {
            originalDisplay = skipButton.style.display;
            skipButton.style.display = "none";
        }
        return function () {
            if (skipButton instanceof HTMLElement && originalDisplay) {
                skipButton.style.display = originalDisplay;
            }
        };
    }, []);
    var updateReseller = function () {
        ApiManager_1.default.updateReseller(record, Number(selectedAccount))
            .then(function () {
            setUpdatedResellerId(Number(selectedAccount));
            setOpenDialog(false);
        })
            .catch(function (e) {
            logger.error(t("Updating partner account failed"), e);
            setOpenDialog(false);
        });
    };
    if (!record)
        return;
    return (react_1.default.createElement(react_admin_1.WrapperField, { sortable: false },
        react_1.default.createElement("div", { className: "d-flex align-items-center" }, record.id !== 1 && (react_1.default.createElement(material_1.Tooltip, { title: "Change partner account" },
            react_1.default.createElement("span", null,
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faRepeat, className: AccountsListAdmin_module_css_1.default["change-partner-icon"], onClick: handleOpenDialog, "data-cy": "changePartnerIcon" }))))),
        react_1.default.createElement(material_1.Dialog, { open: openDialog, onClose: handleCloseDialog, fullWidth: true },
            react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title", "data-cy": "changePartnerDialog" }, t("Change Partner Account")),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.FormControl, { fullWidth: true },
                    react_1.default.createElement(material_1.Select, { value: selectedAccount, onChange: handleChange, className: AccountsListAdmin_module_css_1.default["custom-select"] }, accounts.map(function (account, accountKey) { return (react_1.default.createElement(material_1.MenuItem, { key: accountKey, value: account.value.id, style: {
                            fontFamily: "var(--bs-body-font-family)",
                        } }, account.label)); }))),
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement("div", { style: { marginTop: "15px" } },
                        react_1.default.createElement(q_play_components_1.Button, { onClick: handleCloseDialog, style: { marginRight: "15px" }, size: "normal", text: t("Cancel"), variant: "secondary" }),
                        react_1.default.createElement(q_play_components_1.Button, { onClick: updateReseller, style: { backgroundColor: "#A1C038", width: "136px", color: "var(--info-color)" }, size: "normal", text: t("Update"), isDisabled: accounts.length == 0 || selectedAccount === currentResellerId, dataCy: "changePartnerButton" })))))));
};
var RemoveAccountField = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var record = (0, react_admin_1.useRecordContext)();
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var _a = (0, react_1.useState)(false), openDialog = _a[0], setOpenDialog = _a[1];
    var page = (0, useTypedPage_1.default)();
    var currentlyLoggedInAccountId = page.props.session.current_account.id;
    var softDeleteAccount = function () {
        ApiManager_1.default.softDeleteAccount(record)
            .then(function () {
            refresh();
            setOpenDialog(false);
        })
            .catch(function (e) {
            logger.error(t("Failed to delete account"), e);
            setOpenDialog(false);
        });
    };
    var handleOpenDialog = function () {
        setOpenDialog(true);
    };
    var handleCloseDialog = function () {
        setOpenDialog(false);
    };
    if (!record)
        return;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_admin_1.WrapperField, { sortable: false },
            react_1.default.createElement("div", { className: "d-flex align-items-center" }, record.id !== 1 && (react_1.default.createElement(material_1.Tooltip, { title: record.id === currentlyLoggedInAccountId ? "You cannot delete the currently logged in account" : "Delete account" },
                react_1.default.createElement("span", null,
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, onClick: record.id === currentlyLoggedInAccountId ? undefined : handleOpenDialog, className: record.id === currentlyLoggedInAccountId ? AccountsListAdmin_module_css_1.default["disabled-button"] : AccountsListAdmin_module_css_1.default["delete-icon"], "data-cy": "deleteAccountIcon" })))))),
        react_1.default.createElement(material_1.Dialog, { open: openDialog, onClose: handleCloseDialog, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description", fullWidth: true, "data-cy": "deleteAccountDialog" },
            react_1.default.createElement(material_1.DialogTitle, { id: "alert-dialog-title" }, t("Delete Account")),
            react_1.default.createElement(material_1.DialogContent, null,
                react_1.default.createElement(material_1.DialogContentText, { id: "alert-dialog-description" }, t("Are you sure you want to delete this account?"))),
            react_1.default.createElement(material_1.DialogActions, null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement(q_play_components_1.Button, { onClick: handleCloseDialog, style: { marginRight: "15px" }, size: "normal", text: t("Cancel"), variant: "secondary" }),
                    react_1.default.createElement(q_play_components_1.Button, { onClick: softDeleteAccount, style: { backgroundColor: "#A1C038", width: "136px", color: "var(--info-color)" }, size: "normal", text: t("Delete"), dataCy: "deleteAccountButton" }))))));
};
var AccountsListAdmin = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    return (react_1.default.createElement("div", { style: { width: "640px" } },
        react_1.default.createElement("h1", { className: "ns-font-family-bold ".concat(AccountsListAdmin_module_css_1.default["header-text"]) }, t("Accounts listing")),
        react_1.default.createElement("h6", { className: AccountsListAdmin_module_css_1.default["header-text"] }, t("Shows all accounts")),
        react_1.default.createElement(react_admin_1.Admin, { theme: theme, dataProvider: (0, ra_data_simple_rest_1.default)("/api/list"), disableTelemetry: true, layout: RALayout_1.default },
            react_1.default.createElement(react_admin_1.Resource, { name: "partner_accounts", list: react_1.default.createElement(react_admin_1.ListBase, { sort: { field: "is_reseller", order: "DESC" } },
                    react_1.default.createElement(react_admin_1.Datagrid, { hover: false, sx: RaDataGridSx, bulkActionButtons: false, "data-cy": "accountsListAdminTable" },
                        react_1.default.createElement(react_admin_1.TextField, { source: "name", label: t("Name"), sx: { fontFamily: "Geomanist-bold" }, "data-cy": "nameColumn", sortable: false }),
                        react_1.default.createElement(react_admin_1.TextField, { source: "id", label: t("ID"), sortable: false, "data-cy": "accountIdColumn" }),
                        react_1.default.createElement(react_admin_1.TextField, { source: "players_count", label: t("Players"), sortable: false }),
                        react_1.default.createElement(react_admin_1.TextField, { source: "is_reseller", label: t("Partner"), sortable: true, "data-cy": "isResellerColumn" }),
                        react_1.default.createElement(SwitchAccountField, null),
                        react_1.default.createElement(ElevateToPartnerField, null),
                        react_1.default.createElement(ChangePartnerField, null),
                        react_1.default.createElement(RemoveAccountField, null)),
                    react_1.default.createElement(Pagination_1.default, null)) }))));
};
exports.default = AccountsListAdmin;
